import { render, staticRenderFns } from "./widget-container.vue?vue&type=template&id=5ce8faba"
import script from "./widget-container.vue?vue&type=script&lang=js"
export * from "./widget-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports